import { UserReport, UserReportState } from '@services/userreport/types';

export const ACTIVE_REPORT_STATES: UserReportState[] = [
  'queued',
  'processing',
  'cancellation_requested',
];

export const reportFileName = (report: UserReport) => {
  const extension = report.format ? `.${report.format.toLowerCase()}` : '';
  const normalizedName = report.name.replace(/_report$/, '').replace(/_/g, ' ');
  return `${normalizedName}${extension}`;
};
